/**
 * @file css
 * @author Yu Zong(liuxuanzy@qq.com)
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Jason Miller
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
// DOM properties that should NOT have "px" added when numeric
export var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|^--/i;
var JS_TO_CSS = {};
// Convert an Object style to a CSSText string
export function styleObjToCss(css) {
    var s = css;
    var str = '';
    Object.keys(s).forEach(function (prop) {
        var val = s[prop];
        if (val != null && val !== '') {
            if (str)
                str += ' ';
            str += prop[0] === '-'
                ? prop
                : JS_TO_CSS[prop] || (JS_TO_CSS[prop] = prop.replace(/([A-Z])/g, '-$1').toLowerCase());
            str += ': ';
            str += val;
            if (typeof val === 'number' && !IS_NON_DIMENSIONAL.test(prop)) {
                str += 'px';
            }
            str += ';';
        }
    });
    return str;
}
